<template>
  <div>
    <p class="title_sp">
      <custom-breadcrumb />
    </p>
    <div class="page-header">
      <div class="search-box">
        <el-select clearable placeholder="Store Type" v-model="selectData.storeType" class="search-select">
          <el-option
                v-for="(item, index) in storeTypeMap"
                :key="item.textTitle"
                :label="item.textTitle"
                :value="index"
              ></el-option>
        </el-select>
      </div>
      <div class="date-picker" style="display: flex;">
        <div class="date-picker-title" style="display: flex">Last Ordered time</div>
        <el-date-picker class="el-date-picker" type="daterange" prefix-icon="default-icon" start-placeholder="start date"
          end-placeholder="end date" v-model="selectTime" value-format="yyyy-MM-dd"></el-date-picker>
      </div>
      <div class="search-input">
        <el-input class="search-bar" prefix-icon="el-icon-search" placeholder="Search Store name, Contact name" v-model="selectData.keyWords">
        </el-input>
      </div>
      <el-button type="primary" class="search-btn" @click="searchButton">Search</el-button>
    </div>
    <div class="table-container">
      <el-table class="customer-table" :data="tableData" stripe empty-text="No customers available" :show-empty="false">
        <el-table-column prop="storeName" label="Store Name" width="250">
          <template slot-scope="scope">
      <p class="customer-store-name">{{ scope.row.storeName }}</p>
    </template>
        </el-table-column>
        <el-table-column prop="storeType" label="Store types" width="250" >
          <template slot-scope="scope">
      {{ scope.row.storeType === null || scope.row.storeType === undefined ? '--' : scope.row.storeType }}
    </template>
        </el-table-column>
        <el-table-column prop="fullName" label="Contact name" width="200">
          <template slot-scope="scope">
      {{ scope.row.fullName === null || scope.row.fullName === undefined ? '--' : scope.row.fullName }}
    </template>
        </el-table-column>
        <!-- <el-table-column prop="email" label="Email" width="300">
          <template slot-scope="scope">
      {{ scope.row.email === null || scope.row.email === undefined ? '--' : scope.row.email }}
    </template>
        </el-table-column> -->
        <el-table-column prop="lastOrderTime" label="Last Order Time" width="200">
          <template slot-scope="scope">
      {{ scope.row.lastOrderTime === null || scope.row.lastOrderTime === undefined ? '--' : scope.row.lastOrderTime }}
    </template>
        </el-table-column>
        <el-table-column prop="location" label="Location" min-width="400">
          <template slot-scope="scope">
            <div class="location-col-content"><img v-if="scope.row.location != '--'" src="../../assets/img/gmap-location.png"/>
            <div class="ellipsis">{{ scope.row.location }}</div></div>

          </template>
        </el-table-column>
      </el-table>

    </div>
    <Pagination
    :currentPage="paging.current"
      :total="paging.total"
      :pageSize="paging.size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></Pagination>
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import Pagination from '../components/pagination.vue'
import qs from 'qs'

export default {
  components: { CustomBreadcrumb, Pagination },
  data() {
    return {
      storeTypeMap: [
        {
          // img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x.png',
          textTitle: 'Brick & Mortar Store',
          textSubtitle: 'I sell from my own retail storefront.'
        },
        {
          // img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%281%29.png',
          textTitle: 'Brick & Mortar and Online Store',
          textSubtitle: 'I sell from both retail stores and online stores.'
        },
        {
          // img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%282%29.png',
          textTitle: 'Online Boutique Store',
          textSubtitle: 'I only sell from my own unique website.'
        },
        {
          // img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%283%29.png',
          textTitle: 'Pop-up Store',
          textSubtitle:
            'I sell from a shared marketplace as a vendor, or at events.'
        },
        {
          // img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%284%29.png',
          textTitle: 'Social Media',
          textSubtitle: 'I only sell products on other channels'
        }
      ],
      storeTypeOptions: [],
      tableData: [],
      paging: {},

      selectTime: '',
      selectData: {
        storeType: '',
        keyWords: '',
        pageSize: 20,
        currentPage: 1
      }
    }
  },
  created() {
    // 2.1.7 从GoogleMap跳转过来的要只查询当前的店铺信息
    const storeName = this.$route.query.storeName
    if (storeName) {
      this.selectData.keyWords = storeName
    }
    // this.getStoreType()
    this.search()
  },
  mounted() {
    // 调整日期栏图标位置
    let keyNode = document.querySelector('.el-date-picker')
    let iNode = document.createElement('i')
    iNode.setAttribute('class', 'el-icon-date') // el-icon-bottom
    keyNode.appendChild(iNode)
    iNode.style.position = 'absolute'
    iNode.style.top = '12px'
    iNode.style.right = '12px'
  },

  methods: {
    getStoreType() {
      getAction('/v0.2/store_type').then(res => {
        if (res.success) {
          this.storeTypeOptions = res.result
          for (let option of this.storeTypeOptions) {
            this.storeTypeMap[option.id] = option.storeTypeName
          }
        }
      })
    },
    test() {
      console.log(this.selectTime)
    },
    // getCustomerList(){
    //   getAction('/v0.2/home/customers').then(res=>{
    //   if(res.code === 200){
    //     this.paging = res.result
    //     this.tableData = res.result.records;
    //     for(let customer of this.tableData){
    //       customer.fullName = customer.firstName + ' ' + customer.lastName
    //       customer.location = customer.city + ', ' + customer.country
    //     }
    //   }
    //   else{
    //     console.error(res)
    //   }
    // })
    // },
    searchButton() {
      this.selectData.currentPage = 1
      this.search()
    },
    async search() {
      let searchQuery = this.selectData
      if (!this.selectTime) {
        searchQuery.lastOrderEndTime = undefined
        searchQuery.lastOrderStartTime = undefined
      } else {
        searchQuery.lastOrderStartTime = this.selectTime[0]
        searchQuery.lastOrderEndTime = this.selectTime[1]
      }
      let data = await getAction(`/v0.2/home/customers?${qs.stringify(searchQuery)}`)

      if (data.code === 200) {
        this.tableData = data.result.records
        // this.tableData.push({storeName:"test",state:"",country:""})
        console.log(this.tableData)
        for (let customer of this.tableData) {
          // 处理全名
          if (customer.storeContactName && customer.storeContactName !== '') {
            customer.fullName = customer.storeContactName
          } else {
            if ((!customer.firstName || customer.firstName == '') && (!customer.lastName || customer.lastName == '')) {
              customer.fullName = '--'
            } else if (!customer.firstName || customer.firstName == '') {
              customer.fullName = customer.lastName
            } else if (!customer.lastName || customer.lastName == '') {
              customer.fullName = customer.firstName
            } else {
              customer.fullName = customer.firstName + ' ' + customer.lastName
            }
          }
          // 处理location

          if ((!customer.state || customer.state == '') && (!customer.countryCode || customer.countryCode == '')) {
            customer.location = '--'
          } else if (!customer.state || customer.state == '') {
            customer.location = customer.countryCode
          } else if (!customer.countryCode || customer.countryCode == '') {
            customer.location = customer.state
          } else {
            customer.location = customer.state + ',' + customer.countryCode
          }
          if (customer.storeType) {
            customer.storeType = this.storeTypeMap[customer.storeType].textTitle
          }
        }

        this.paging = data.result
      }
      // console.log(this.tableData)
    },
    handleSizeChange(val) {
      this.selectData.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`, this.selectData)
      this.selectData.currentPage = val
      this.search()
    },
    viewDetail(userId) {
      this.$router.push({
        path: 'CustomersDetail',
        query: {'userId': userId}
      })
      // this.$router.push({ path: 'Order' })
    }

  }

}
</script>

<style lang="less" scoped>
p,
span {
  display: block;
  margin-bottom: 10px;
}

.title_sp {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 600;
  color: #262B2F;
}

.page-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.page-header div {
  margin-right: 10px;
}

.el-date-picker {
  width: 286px;
}

.search-input {
  flex-grow: 1;
  max-width: 560px;
  //margin-right: -10px !important;
}

.date-picker-title {
  justify-content: center;
  align-items: center;
  width: 150px;
  border: 1px solid rgb(220, 223, 220);
  color: rgb(220, 223, 220);
  margin-right: 0 !important
}

/deep/ .default-icon {
  display: none;
}
.el-table {
  border-collapse: separate; /* 使用独立的边框模型 */
  border-spacing: 0; /* 设置边框间距为0 */
  border: 1px solid #ebeef5; /* 设置外边框样式 */
  margin-top: 20px;
  min-height: 0;

  min-width: fit-content;

  .el-table__row {
    border-bottom: 1px solid #ebeef5; /* 设置行边框样式 */

  }
  .el-table__row--striped {
    background-color: #2f436b; /* 设置斑马纹背景色 */
  }
}
.customer-store-name{
  cursor: pointer;
  text-decoration: underline;

}

// .ellipsis {
//   white-space: nowrap; /* 禁止换行 */
//   overflow: hidden; /* 超出部分隐藏 */
//   text-overflow: ellipsis; /* 超出部分以省略号表示 */
// }

.location-col-content{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.search-box{
  width:200px
}
.search-select{
  width:200px
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/customer.vue